module.exports = __webpack_public_path__ + "static/media/sakura.cc91ec1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sakura.mp4
// module id = 760u
// module chunks = 1